export const EXCMDEVICEMODEL_SHOW_RESET = 'EXCMDEVICEMODEL_SHOW_RESET'
export const EXCMDEVICEMODEL_SHOW_SET_ERROR = 'EXCMDEVICEMODEL_SHOW_SET_ERROR'
export const EXCMDEVICEMODEL_SHOW_SET_RETRIEVED = 'EXCMDEVICEMODEL_SHOW_SET_RETRIEVED'
export const EXCMDEVICEMODEL_SHOW_TOGGLE_LOADING = 'EXCMDEVICEMODEL_SHOW_TOGGLE_LOADING'
